<div class="report-header" *ngIf="report">
    <div class="rh-left">
        <div class="rh-title">
            <h1 class="rh-title-h1">{{report.baer_name}} ({{report.report_num}})</h1>
        </div>
        <div class="rh-sub">
            2500-8 Report ID: {{report.report_id}}
            <span class="pipe-color"> | </span>
            Action: {{report.report_num == 0 ? "Pre-assessment" : report.report_num == 1 ? "Initial" : "Interim"}}
            <span class="pipe-color"> | </span>
            Report
            Status: <mat-chip [ngClass]="'chip-r-'+report.report_status_id">{{report.report_status_id |
                reportStatusBadge}}</mat-chip>
            @if (report.report_status_id == 2) {
            <span class="spacer">|</span>Authorization Status:
            <mat-chip [ngClass]="'chip-a-'+report?.authorization_status_id">
                {{report.authorization_status_id | authorizationStatusBadge}}
            </mat-chip>
            }
            @if (report.page_1_status_id == 2 && report.page_2_status_id == 2 && report.page_3_status_id == 2) {
            <span class="spacer">|</span>
            <a (click)="download(report.report_id)" class="export-header">
                <fa-icon class="fa-sm" [icon]="faFileArrowDown"></fa-icon>
                <span>Export PDF</span>
            </a>
            }
        </div>
    </div>
    <div class="rh-right">
        <div class="save-info-div" *ngIf="autosave.saving && nav() == ''">
            <div>
                <mat-spinner [color]="'accent'" [diameter]="20"></mat-spinner>
            </div>
            Saving...
        </div>
        <div class="save-info-div" *ngIf="nav() != ''">
            <div>
                <mat-spinner [color]="'accent'" [diameter]="20"></mat-spinner>
            </div>
            Saving...
        </div>
        <div class="save-info-div" *ngIf="autosave.saved && nav() == ''">
            <fa-icon [icon]="faCheck" class="save-check" aria-label="check"></fa-icon>
            {{ savedText }}
        </div>
        <button (click)="save_close()" style="height: 40px;font-weight: 700;" mat-flat-button color="accent"
            *ngIf="report_page != maxPage+1">Save & Close</button>
        <button (click)="save_close()" style="height: 40px;font-weight: 700;" mat-flat-button color="accent"
            *ngIf="report_page == maxPage+1">Close</button>
    </div>
</div>
<div class="report-main" *ngIf="report">
    <div class="report-nav" *ngIf="report_page != maxPage+1">
        <div class="rnav-header">
            <div>2500-8 Report</div>
        </div>
        @for (name of pageNames; track name; let page = $index) {
        <div
            [ngClass]="'rnav-item rnav-status-'+(report_page==(page+1) ? (current_status ?? report['page_'+(page+1)+'_status_id']) : report['page_'+(page+1)+'_status_id']) +' rnav-current-'+(report_page==page+1)">
            <button class="anchor-button" (click)="goToPage(page+1)">
                <div>
                    @if((report_page==(page+1) && (current_status ?? report['page_'+(page+1)+'_status_id']) == 1) ||
                    (report_page!=(page+1) && report['page_'+(page+1)+'_status_id'] == 1)){
                    <mat-icon class="current-page">contrast</mat-icon>
                    }
                    @else {
                    @if((report_page==(page+1) && (current_status ?? report['page_'+(page+1)+'_status_id']) == 2) ||
                    (report_page!=(page+1) && report['page_'+(page+1)+'_status_id'] == 2)) {
                    <mat-icon>check_circle</mat-icon>
                    }
                    @else {<mat-icon>panorama_fish_eye</mat-icon>}
                    }
                    {{page+1}}. {{name}}
                </div>
            </button>
        </div>
        }
    </div>
    <div class="report-right-area">
        <div class="report-area">
            <div class="report-section" [ngClass]="comment_expand ? 'report-section-comment' : ''"
                *ngIf="report && report_type != 'No Treatment' && report_type != 'Pre-assessment Request'">
                @if(report_page != maxPage+1) {
                <ng-container *ngTemplateOutlet="underReview"></ng-container>
                }
                @switch (report_page) {
                @case (1) {<app-report-type [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-report-type>}
                @case (2) {<app-burned-area [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-burned-area>}
                @case (3) {<app-watershed-condition [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-watershed-condition>}
                @case (4) {<app-analysis-summary [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-analysis-summary>}
                @case (5) {<app-recommended-treatment [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-recommended-treatment>}
                @case (6) {<app-emergency-stabilization [report]="report" [(nav)]="nav" page="6"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-emergency-stabilization>}
                @case (7) {<app-team-supporting [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-team-supporting>}
                @case (8) {<app-select-line-officer [report]="report" [(nav)]="nav" [is_co]="is_co"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-select-line-officer>}
                @case (9) {<app-submission [report]="report" [(nav)]="nav" [is_co]="is_co"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-submission>}
                @default {<div>No Report Page exists for this ID. please try again. {{report_page}}</div>}
                }
            </div>
            <div class="report-section" [ngClass]="comment_expand ? 'report-section-comment' : ''"
                *ngIf="report && report_type == 'No Treatment'">
                @if(report_page != maxPage+1) {
                <ng-container *ngTemplateOutlet="underReview"></ng-container>
                }
                @switch (report_page) {
                @case (1) {<app-report-type [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-report-type>}
                @case (2) {<app-burned-area [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-burned-area>}
                @case (3) {<app-watershed-condition [report]="report" [(nav)]="nav" [autosave]="autosave"
                    [optional]="true" (status)="statusChange($event)" (loaded)="subLoaded()"></app-watershed-condition>}
                @case (4) {<app-analysis-summary [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-analysis-summary>}
                @case (5) {<app-assessment-cost [report]="report" [(nav)]="nav" (status)="statusChange($event)"
                    (loaded)="subLoaded()"></app-assessment-cost>}
                @case (6) {<app-team-supporting [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true"
                    (status)="statusChange($event)" (loaded)="subLoaded()" page="6"></app-team-supporting>}
                @case (7) {<app-select-line-officer [report]="report" [(nav)]="nav" [is_co]="is_co" page="7"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-select-line-officer>}
                @case (8) {<app-submission [report]="report" [(nav)]="nav" [is_co]="is_co"
                    (loaded)="subLoaded()"></app-submission>}
                @default {<div>No Report Page exists for this ID. please try again. {{report_page}}</div>}
                }
            </div>
            <div class="report-section" [ngClass]="comment_expand ? 'report-section-comment' : ''"
                *ngIf="report && report_type == 'Pre-assessment Request'">
                @if(report_page != maxPage+1) {
                <ng-container *ngTemplateOutlet="underReview"></ng-container>
                }
                @switch (report_page) {
                @case (1) {<app-report-type [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-report-type>}
                @case (2) {<app-burned-area [report]="report" [(nav)]="nav" [autosave]="autosave" [simple]="true"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-burned-area>}
                @case (3) {<app-analysis-summary [report]="report" [(nav)]="nav" [autosave]="autosave" [simple]="true"
                    page="3" (status)="statusChange($event)" (loaded)="subLoaded()"></app-analysis-summary>}
                @case (4) {<app-recommended-treatment [report]="report" [(nav)]="nav" [autosave]="autosave"
                    (status)="statusChange($event)" page="4" (status)="statusChange($event)"
                    (loaded)="subLoaded()"></app-recommended-treatment>}
                @case (5) {<app-emergency-stabilization [report]="report" [(nav)]="nav" page="5"
                    (status)="statusChange($event)" (status)="statusChange($event)"
                    (loaded)="subLoaded()"></app-emergency-stabilization>}
                @case (6) {<app-team-supporting [report]="report" [(nav)]="nav" [autosave]="autosave" [optional]="true"
                    page="6" (status)="statusChange($event)" (loaded)="subLoaded()"></app-team-supporting>}
                @case (7) {<app-select-line-officer [report]="report" [(nav)]="nav" [is_co]="is_co" page="7"
                    (status)="statusChange($event)" (loaded)="subLoaded()"></app-select-line-officer>}
                @case (8) {<app-submission [report]="report" [(nav)]="nav" [is_co]="is_co" (loaded)="subLoaded()"></app-submission>}
                @default {<div>No Report Page exists for this ID. please try again. {{report_page}}</div>}
                }
            </div>
            <div class="report-comments" [ngClass]="comment_expand ? 'expand-comment' : ''"
                *ngIf="report_page != maxPage+1">
                @if(comments_unresolved) {
                <button mat-icon-button aria-label="chat_button" class="icon-button" (click)="comment_expand = true"
                    *ngIf="!comment_expand">
                    <fa-icon [icon]="faMessage" class="chat-count-red" aria-label="chat"></fa-icon><span
                        class="button-text chat-text-red">{{comments?.length ?? 0}}</span>
                </button>
                } @else {
                <button mat-icon-button aria-label="chat_button" class="icon-button" (click)="comment_expand = true"
                    *ngIf="!comment_expand">
                    <fa-icon [icon]="faMessage" class="chat-count" aria-label="chat"></fa-icon><span
                        class="button-text chat-text">{{comments?.length ?? 0}}</span>
                </button>
                }
                <div class="comment-header" *ngIf="comment_expand">
                    <button class="comment-button">
                        Comments<span>({{comments?.length ?? 0}})</span></button>
                    <button class="comment-add-button" *ngIf="comment_expand && is_co" (click)="addComment()"
                        matTooltip="Add comment" matTooltipClass="tooltipClass">
                        <mat-icon>add</mat-icon></button>
                    <button mat-icon-button class="icon-button" (click)="comment_expand = false"
                        matTooltip="Hide comments" matTooltipClass="tooltipClass"
                        matTooltipPosition="left"><mat-icon>keyboard_tab</mat-icon></button>
                </div>
                <div class="no-comments" *ngIf="comment_expand && ((comments?.length ?? 0) == 0)">
                    <fa-icon [icon]="faCommentSlash" class="chat-count" aria-label="no messages"></fa-icon>
                    <div class="no-comments-title">No Comments</div>
                    <div class="no-comments-text" *ngIf="!is_co">
                        No revisions have been requested
                    </div>
                    <div class="no-comments-text" *ngIf="is_co">
                        Leave a comment to request revisions to the report
                    </div>
                    <button class="comment-add-button" *ngIf="comment_expand && is_co"
                        (click)="addComment()"><mat-icon>add</mat-icon> Add Comment</button>
                </div>
                <div class="comments" *ngIf="comment_expand && ((comments?.length ?? 0) > 0)">
                    @for(comment of comments; track comment) {
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>
                                <button class="anchor-button" (click)="goToPage(comment.section)">
                                    {{comment.section}}. {{findPage(comment.section) }}
                                </button>
                            </mat-card-title>
                            <div class="comment-title-align">
                                <mat-icon class="resolved" matTooltip="Resolved" matTooltipClass="tooltipClass"
                                    matTooltipPosition="left" *ngIf="comment.resolved && is_co">check</mat-icon>
                                <button *ngIf="!is_co && !comment.resolved" class="resolve-button" mat-icon-button
                                    (click)="markAsResolved(comment, true)" aria-label="Mark as Resolved"
                                    matTooltip="Mark as Resolved" matTooltipClass="tooltipClass"
                                    matTooltipPosition="left">
                                    <mat-icon class="unresolved-icon">panorama_fish_eye</mat-icon>
                                </button>
                                <button *ngIf="!is_co && comment.resolved" class="resolve-button" mat-icon-button
                                    (click)="markAsResolved(comment, false)" aria-label="Mark as Unresolved"
                                    matTooltip="Mark as Unresolved" matTooltipClass="tooltipClass"
                                    matTooltipPosition="left">
                                    <mat-icon class="resolved-icon">check</mat-icon>
                                </button>
                                <button *ngIf="is_co" class="comment-menu" mat-icon-button [matMenuTriggerFor]="menu"
                                    aria-label="Comment Menu" matTooltip="Actions menu" matTooltipClass="tooltipClass"
                                    matTooltipPosition="left">
                                    <mat-icon>more_horiz</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button class="comment-edit" mat-menu-item (click)="editComment(comment)">
                                        <fa-icon class="fa-sm" [icon]="faEdit" style="color: #216E1F;"></fa-icon>
                                        <span>Edit</span>
                                    </button>
                                    <button class="comment-delete" mat-menu-item (click)="deleteComment(comment)">
                                        <fa-icon class="fa-sm" [icon]="faTrash"></fa-icon>
                                        <span>Delete</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </mat-card-header>
                        <mat-card-content>
                            <span class="comment-info"><b>{{comment.commentator_name}}</b> • {{comment.updated_on |
                                date:"MM/dd/yyyy"}}</span>
                            <span class="comment-detail">{{comment.comment}}</span>
                        </mat-card-content>
                    </mat-card>
                    }
                </div>
            </div>
        </div>
        <div class="report-footer" *ngIf="report_page != (maxPage + 1)" style="z-index: 1000;">
            <div class="rf-left">
                @if (report_page > 1) {
                <button class="nav-btn" (click)="back()"><mat-icon>arrow_back_ios</mat-icon>{{report_page - 1}}.
                    {{pageNames[report_page - 2]}}</button>
                }

            </div>
            <div class="rf-right">
                @if (report_page == maxPage) {
                <button class="submit-btn" (click)="forward()" *ngIf="!is_co && report.report_status_id != 1 && report.authorization_status_id == null"
                    color="accent" [disabled]="
                report.page_1_status_id != 2 ||
                report.page_2_status_id != 2 ||
                report.page_3_status_id != 2 ||
                report.page_4_status_id != 2 ||
                report.page_5_status_id != 2 ||
                report.page_6_status_id != 2 ||
                report.page_7_status_id != 2 ||
                (maxPage >= 8 && report.page_8_status_id != 2 )
                "><span>Send for Review</span>
                    <mat-icon>send</mat-icon></button>
                <button class="submit-btn" (click)="forward()" *ngIf="is_co && report.report_status_id != 1 && report.authorization_status_id == null"
                    color="accent" [disabled]="unresolved"
                    matTooltip="All feedback must be fixed and completed before requesting a final report."
                    matTooltipClass="tooltipClass"><span>Request Final Report</span>
                    <mat-icon>send</mat-icon></button>
                <button class="submit-btn" (click)="forward()" *ngIf="report.report_status_id == 1" color="accent"
                    [disabled]="unresolved || !complete"><span>Send Final Report</span>
                    <mat-icon>send</mat-icon></button>
                } @else {
                <button class="nav-btn" (click)="forward()">{{report_page + 1}}.
                    {{pageNames[report_page]}}<mat-icon>arrow_forward_ios</mat-icon></button>
                }
            </div>
        </div>
    </div>
</div>

<ng-template #underReview>
    <div class="yellow-warning" *ngIf="report.report_status_id == 3 && !is_co">
        <fa-icon [icon]="faFile" class="faFile" aria-label="Warning"></fa-icon>
        <div class="support-text">
            <b>The report is under review by the Regional BAER Coordinator.</b>
            <span>
                <br>
            </span>
            If additional information or changes are requested you will be notified in the Comments sidebar.
        </div>
    </div>
</ng-template>